import Moment from 'moment';
import SystemFieldProto from '../../proto/system-field-proto';
import AggregateMoment from "../../aggregate/aggregate-moment";
import AggregateMomentComponent from "../components/aggregate-moment";
import normalizeDate from "../../import/normalize/normalize-date";
import FieldDateViewInImport from "../../import/view-in-preview/date-view-in-import";

export default class ScheduleField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.SCHEDULE;
    }

    get sortHintMessage() {
        return 'Sort by schedule';
    }

    getCsvValue(item) {
        return gd.const.systemStatus.isOpen(item.systemStatus) && item.scheduleDate ? Moment(item.scheduleDate).format("YYYY-MM-DD") : '';
    }

    getValue(item) {
        let value = item.actionRequiredUserId && item.scheduleStatus === gd.const.task.scheduleStatus.SCHEDULED ? item.scheduleDate : null;
        if (value && value.isBefore(Moment())) value = Moment();
        return value;
    }

    getAggregateClass() {return AggregateMoment}
    getAggregateOptions() {return [
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.RANGE
    ]}

    listItemSortFunctions(sort) {
        const sortFunc = i => {
            if (i.type === 'project') return 0;
            const { scheduleDate, scheduleStatus } = i.item;
            let out;
            if (scheduleStatus === 0)      out = 0;
            else if (scheduleDate)         out = scheduleDate.unix();
            else if (scheduleStatus === 2) out = scheduleStatus === 2 ? Moment().startOf('day').add(100, 'years').unix() : 0;
            return out;
        };

        return {
            functions: [sortFunc],
            directions: [sort]
        }
    }

    get AggregateComponent() {return AggregateMomentComponent.bind(null, this.getAggregateOptions())}


    // IMPORT

    normalizeCSVValue(value) {
        return normalizeDate(value);
    }

    getComponentViewInImport() {
        return FieldDateViewInImport;
    }


}